var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWorld(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 1.25C5.16773 1.25 1.25 5.16773 1.25 10C1.25 14.8323 5.16773 18.75 10 18.75C14.8323 18.75 18.75 14.8323 18.75 10C18.75 5.16773 14.8323 1.25 10 1.25Z",
    stroke: "#001A3A",
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.99948 1.25C7.55664 1.25 5.25977 5.16773 5.25977 10C5.25977 14.8323 7.55664 18.75 9.99948 18.75C12.4423 18.75 14.7392 14.8323 14.7392 10C14.7392 5.16773 12.4423 1.25 9.99948 1.25Z",
    stroke: "#001A3A",
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.833 15.8349C14.2243 14.6928 12.1992 14.0117 9.99949 14.0117C7.79979 14.0117 5.77467 14.6928 4.16602 15.8349M4.16602 4.16797C5.77467 5.3101 7.79979 5.99117 9.99949 5.99117C12.1992 5.99117 14.2243 5.3101 15.833 4.16797",
    stroke: "#001A3A",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M18.75 10H1.25H18.75ZM10 1.25V18.75V1.25Z",
    stroke: "#001A3A",
    strokeMiterlimit: 10
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWorld);
export default __webpack_public_path__ + "static/media/world.6b706d91.svg";
export { ForwardRef as ReactComponent };